import { render, staticRenderFns } from "./complementos.vue?vue&type=template&id=61648f40&"
import script from "./complementos.vue?vue&type=script&lang=js&"
export * from "./complementos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports